import { makeAutoObservable } from "mobx";
import type { Member } from "@smartsuite/automation-engine-api";

export class MembersStore {
  list: Member[] = [];
  pageSize: number = 20;

  constructor() {
    makeAutoObservable(this);
  }

  setList(members: Member[]): void {
    this.list = members;
  }
}
